import * as React from 'react';
import { copyrightText, privacyText } from '../strings/publishedCalendar.locstring.json';
import { getCalendarNameAndUser } from 'owa-publishedcalendar-settings';
import { Link } from '@fluentui/react/lib/Link';
import loc from 'owa-localize';
import { observer } from 'mobx-react-lite';

import styles from './PublishedCalendar.scss';

/**
 * The calendar bar that shows up on top of Published Calendar surface with the calendar name and the copyright text
 */
export default observer(function PublishedCalendarNameBar() {
    return (
        <div className={styles.calendarNameBar}>
            <div className={styles.calendarNameAndCopyrightContainer}>
                <div>{getCalendarNameAndUser()}</div>
                <div className={styles.copyrightAndPrivacy}>
                    <div className={styles.copyright}>{loc(copyrightText) + ' |'}</div>
                    <Link
                        className={styles.copyrightLink}
                        href="https://go.microsoft.com/fwlink/?LinkId=521839"
                        target="_blank">
                        {loc(privacyText)}
                    </Link>
                </div>
            </div>
        </div>
    );
});
